import { render, staticRenderFns } from "./OnlineDossier.vue?vue&type=template&id=6ab60f74"
import script from "./OnlineDossier.vue?vue&type=script&lang=js"
export * from "./OnlineDossier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports